module.exports = __webpack_public_path__ + "static/media/FT-FONDO-VR.69b8d749.jpg";